import { usePrefersReducedMotion } from '@app/pages/i/components/ProductConfigurator/usePrefersReducedMotion';
import React, { useCallback } from 'react';

export const useScrollIntoView = () => {
  const prefersReducedMotion = usePrefersReducedMotion();

  const scrollIntoView = useCallback(
    (elementRef: React.RefObject<HTMLElement>) => {
      if (elementRef.current) {
        elementRef.current.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      }
    },
    [prefersReducedMotion]
  );

  return {
    scrollIntoView,
  };
};
